import { langIf } from './types';
export const langs: langIf = {
  title: 'title',
  description: 'description',
  createFirstClock: 'createFirstClock',
  createInGameClock: 'createInGameClock',
  openMapView: 'openMapView',
  inGameTimeisDifferentForEachSave: 'inGameTimeisDifferentForEachSave',
  selectCurrentInGameTime: 'selectCurrentInGameTime',
  pressSubmitWhenTimeChanged: 'pressSubmitWhenTimeChanged',
  morning: 'morning',
  day: 'day',
  evening: 'evening',
  night: 'night',
  back: 'back',
  close: 'close',
  next: 'next',
  privacyPolicy: 'privacyPolicy',
  beforeUsing: 'beforeUsing',
};
